<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title>
      <v-row
        class="mb-12"
        no-gutters
      >
      <v-col
        cols="12"
      >
        <v-alert
          color="error"
        >
          <div class="white--text">
            Stampando i bollettini verrà intaccata la giacenza
          </div>
          <div class="white--text font-weight-bold">
            Bollettini selezionati {{ geTeacherIdsSelected.length }}/50
          </div>
        </v-alert>
      </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <ValidationProvider
            rules="required"
            vid="propagandist"
            :name="$t('fields.propagandist').toLowerCase()"
            v-slot="{ errors }"
        >
          <PropagandistSelect
            :errors="errors"
            v-model="form.propagandist_id"
          >
          </PropagandistSelect>
        </ValidationProvider>


          <ValidationProvider
                rules="required"
                vid="name"
                :name="$t('fields.note').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.name"
                :counter="255"
                :label="$t('fields.note')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </ValidationObserver>

            <v-container fill-height fluid>
              <v-row>
                <v-flex xs6 class="mr-2">
                 <AutoComplete
                  :value="searchTeacher"
                  v-model="searchTeacher"

                  key-value="id"
                  key-name="fulltext"
                  enable-chips
                  enable-clearable
                  enable-autofocus
                  :items="teachers"
                  :label="$t('fields.teacher')"
                  @search="searchTeachers"
                  @input="fetchTeacherIfExist"
                  @clear="deleteSelectedTeacher"
                  :delay="900"
                >
                </AutoComplete>

                </v-flex>

                <v-flex xs3 class="mr-2">
                <v-select
                  :items="years"
                  multiple
                  v-model="filters.years"
                  attach
                  chips
                  :label="$t('fields.years')"
                >
                </v-select>
                </v-flex>
                <v-flex xs2 class="mr-2 mt-2">
                  <Search
                    v-model="filters.isbn"
                    :label="$t('SEARCH_BOOK_ISBN')"
                    :delay="500"
                  />
                </v-flex>
              </v-row>
            </v-container>
            <v-data-table
               item-key="campaign_book.id"
              :headers="headers"
              :items="items"
              :server-items-length="totalItems"
              :no-data-text="$t('NO_DATA')"
              :no-results-text="$t('NO_DATA')"
              hide-default-footer
              :options.sync="pagination"
              :loading="loading"
              class="elevation-1"

            >

            <template v-slot:[`item.checkbox`]="{ item }">
              <v-checkbox
                v-model="bookSelected"
                :value="item.campaign_book.id"
                :disabled=" getProductAvailability(item.book.isbn) <= 0 && !getCampaignBookIdSelected.includes(item.campaign_book.id)"
              ></v-checkbox>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              {{ $t(`campaign_statuses.${getLastStatus(item.campaign_book.statuses).status}`) }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
                  {{ getLastStatus(item.campaign_book.statuses).updated_at | timeFormat }}
            </template>
            <template v-slot:[`item.teachers.surname`]="{ item }">
                  {{ item.teacher.fullname }}
            </template>

            <template v-slot:[`item.title`]="{ item }">
                  {{ item.book.title }}
            </template>

            <template v-slot:[`item.isbn`]="{ item }">
                  {{ item.book.isbn }}
            </template>

            <template v-slot:[`item.volume`]="{ item }">
                  {{ item.book.volume }}
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              <v-badge
                v-if="getProductAvailability(item.book.isbn)"
                color="error"
                :content="getProductAvailability(item.book.isbn)"
                inline
              ></v-badge>
              <span v-else>0</span>
              {{  }}
            </template>

            <template v-slot:[`item.book_type`]="{ item }">
                  {{ item.book.book_type }}
            </template>

            <template v-slot:[`item.editor`]="{ item }">
                  {{ item.editor.name }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
                  {{ item.campaign_book.created_at | timeFormat }}
            </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <Paginator
          :total-items="totalItems"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.itemsPerPage"
          @change="fetchData"
        />
    </div>

    </v-card-text>
    <v-card-actions>
      <v-btn :disabled="isNotReadyToSave" @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapGetters, mapState } from 'vuex';


  import { campaignsService } from '../../../utils/services/campaigns.service';
  import { teachersService } from '../../../utils/services/teachers.service';
  import { warehousesService } from '../../../utils/services/warehouses.service';


  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';
  import AutoComplete from '../../shared/Inputs/AutoComplete';
  import Search from '../../shared/Inputs/Search.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'BullettinManualModal',
    components: {
      PropagandistSelect,
      AutoComplete,
      Search,
      Paginator,
    },
    data() {
      return {
        stored: null,
        loading: false,
        items: [],
        itemsObject: {},
        products: {},
        bookSelected: [],
        totalItems: 0,
        searchTeacher: null,
        teacher: {},
        teachers: [],
        years: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        form: {
         name: '',
         shipping_type: 'ALL',
         propagandist_id: null,
         teacherIds: [],
         schoolIds: [],
         campaignBookIds: [],
        },
        filters: {
          searchTeacher: null,
          teacherId: null,
          years: null,
          isbn: null,
          statuses: ['ASSIGNED', 'STATUS_BOOKED'],
          shippingType: ['SCHOOL', 'HOME'],
        },
        headers: [
          { text: '', value: 'checkbox', sortable: false },
          { text: this.$t('fields.teacher'), value: 'teachers.surname' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume' },
          { text: this.$t('fields.editor'), value: 'editor' },

          { text: this.$t('fields.type_shipping'), value: 'shipping_type' },
          { text: this.$t('fields.book_type'), value: 'book_type' },

          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.status'), value: 'status', sortable: false },
          { text: this.$t('fields.updated_at'), value: 'updated_at' },
          { text: this.$t('fields.quantity'), value: 'qty' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        errors: {},
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      ...mapGetters('user', ['currentUser']),

      geTeacherIdsSelected() {
        const tmp = [];
        this.getCampaignBookIdSelected.forEach((campaignBookId) => {
          tmp.push(this.itemsObject[campaignBookId].teacher.id);
        });
        return [...new Set(tmp)];
      },

      getBooksISBNSelected() {
        const tmp = [];
        this.getCampaignBookIdSelected.forEach((campaignBookId) => {
          tmp.push(this.itemsObject[campaignBookId].book.isbn);
        });

        return tmp;
      },

      getCampaignBookIdSelected() {
        return this.bookSelected;
      },

      getProducts() {
        return this.products;
      },

      arrayCountValues() {
        let v; const
        freqs = {};

        // for each v in the array increment the frequency count in the table
        for (let i = this.getBooksISBNSelected.length; i--;) {
            v = this.getBooksISBNSelected[i];
            if (freqs[v]) freqs[v] += 1;
            else freqs[v] = 1;
        }

        // return the frequency table
        return freqs;
    },

      isNotReadyToSave() {
        return !this.getCampaignBookIdSelected.length;
      },
      requestFilters() {
        const filters = {
          teacher_id: this.filters.teacherId,
          years: this.filters.years,
          isbn: this.filters.isbn,
          statuses: this.filters.statuses,
          shipping_type: this.filters.shippingType,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
      getSkuVisibles() {
        return this.items.map(x => x.book.isbn);
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),

      getProductAvailability(isbn) {
          return (this.getProducts[isbn] || 0) - (this.arrayCountValues[isbn] || 0);
      },

      deleteSelectedTeacher() {
        this.teacher = {};
      },

      initYears() {
        this.years = [];
        const year = new Date().getFullYear();
        for (let i = 0; i <= 5; i += 1) {
          this.years.push(year - i);
        }
      },

      searchTeachers(val) {
        this.filters.searchTeacher = val;
        this.fetchTeachers();
      },

      async fetchProductQuantity() {
        const response = warehousesService.productQuantityAvailableInWarehouse(
          this.currentUser.user.warehouses[0], {
          filters: {
            skuIn: this.getSkuVisibles,
          },
        });

        return response;
      },

      async fetchData(page) {
        this.loading = true;
        this.fetchCampaigns(page).then(
          campaignresponse => {
            this.items = campaignresponse.data.data;
            campaignresponse.data.data.forEach((item) => {
              this.itemsObject[item.campaign_book.id] = item;
            });

            this.totalItems = campaignresponse.data.meta.total;
            this.pagination = this.getPagination(
              campaignresponse.data.meta,
              { oldPagination: this.pagination, page },
            );
            return this.fetchProductQuantity();
          },
        ).then(productresponse => {
            const isbnKey = Object.keys(productresponse.data.data);
            isbnKey.forEach(key => {
              const { isbn, qty } = productresponse.data.data[key];
              this.products[isbn] = qty;
            });
        })
        .catch(error => {
          console.log(error);
          this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchTeachers() {
        this.loading = true;
        return teachersService.index({
          filters: {
            search: this.filters.searchTeacher,
            sortBy: ['surname', 'name'],
            sortDesc: [false, false],
          },
          itemsPerPage: 100,
        })
        .then(response => {
          this.teachers = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchTeacherIfExist(id) {
        if (id > 0) {
          this.filters.teacherId = id;
          await this.fetchTeacher(id);
        } else {
          this.filters.teacherId = 0;
        }
      },

      fetchTeacher(id) {
        this.loading = true;
        return teachersService.get(id)
        .then(response => {
            this.teacher = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },


      async fetchCampaigns(forcePage) {
        const { page, itemsPerPage } = this.pagination;
        const response = await campaignsService.teacherIndex({
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        });

        return response;
      },

      async save() {
        const isValid = await this.$refs.form.validate();

        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.form.teacherIds = this.geTeacherIdsSelected;
              this.form.campaignBookIds = this.getCampaignBookIdSelected;
              this.options.onSave(
                this.form,
                this.$refs.form,
              )
              .then(() => {
                  this.loadingModal(false);
              }).then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      this.initYears();
      await this.fetchData(1);
    },

    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchData(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchData(1);
          }
        },
      },
    },

  };
</script>
